"use strict";const e=require("./base-component-_c7CmBvl.js"),i=s=>e._n(s,"disabled")||e.K(s,"disabled")==="true";exports.isDisabled=i;
//# sourceMappingURL=isDisabled-BI_fUUV9.js.map
